import CustomInput from "./CustomInput";

class NullInput extends CustomInput {
  transform = value => "";

  validate = value => true;
}

export default NullInput;

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// export default function NullInput(props) {
//   return (
//     <MaskedInput
//       mask="x"
//       placeholder=""
//       {...props}
//       formatCharacters={{
//         x: {
//           validate: char => /\s/.test(char),
//           transform: char => ""
//         }
//       }}
//     />
//   );
// }
